/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Limpar seleção',
  'paginated-picker.async-select.menu-list.error-message.error-message': 'Não foi possível recuperar os dados',
  'paginated-picker.async-select.menu-list.error-message.retry-message': 'Clique para tentar de novo',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Carregando...',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Ver mais',
  'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} de {totalCount}',
  'paginated-picker.async-select.select.no-options-message.no-options-message': 'Nenhuma correspondência encontrada',
  'paginated-picker.async-select.select.option.error-message': 'Não foi possível recuperar os dados',
  'paginated-picker.async-select.select.option.retry-message': 'Clique para tentar de novo',
  'paginated-picker.async-select.select.search-placeholder': 'Pesquisar',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Mostrar lista completa'
};